export const skeletonDefaults = {
  type: 'rect' as const,
  animation: 'fade' as const,
  color: '#EBEBEB',
  waveColor: 'white',
};
